import { Directive, HostBinding, inject } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { CurrentDocumentService } from '@formbird/services';
@Directive({
    selector: '[ftBackgroundImage]',
    standalone: true
})
export class BackgroundImageDirective {
    private currentDocumentService = inject(CurrentDocumentService);


    @HostBinding('style.background-image') public backgroundImage: SafeStyle;
    @HostBinding('class') class: string = 'background-image-holder';

    constructor() {
        const sanitizer = inject(DomSanitizer);

        const setBackground = (bg) => {
            this.backgroundImage = sanitizer.bypassSecurityTrustStyle(`url("${bg}")`);
        }


        const config = (<any>window).ftClientConfig;
        if (config.backgroundImage) {
            setBackground(config.backgroundImage);
        }

        this.currentDocumentService.documentData$.subscribe((data: any) => {
            if (data.template?.backgroundImage) {
                setBackground(data.template.backgroundImage);
            }
        });
    }
}
